// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"05610c36","453":"ef09b767","728":"05610c36"}[chunkId] + ".chunk.js";
};